import React from 'react';
import { useLocation } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { useHeaderSearchOptional } from '../../contexts/HeaderSearchContext';
import * as FiIcons from 'react-icons/fi';

const { FiBell, FiSearch } = FiIcons;

const Header = () => {
  const location = useLocation();
  const headerSearch = useHeaderSearchOptional();
  
  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/dashboard/surveys')) return 'Survey Responses';
    if (path.includes('/dashboard/leads')) return 'Lead Pipeline';
    switch (path) {
      case '/': return 'Dashboard';
      case '/events': return 'Events';
      case '/events/create': return 'Create Event';
      case '/leads': return 'Lead Pipeline';
      case '/student-dashboard': return 'My Events';
      case '/admin': return 'Admin Panel';
      case '/payments': return 'Payment History';
      default: return 'Prosperity Leaders';
    }
  };

  return (
    <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-4 sticky top-0 z-30 shadow-sm">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent">
            {getPageTitle()}
          </h2>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="relative">
            <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
            <input
              type="text"
              value={headerSearch?.query ?? ''}
              onChange={(e) => headerSearch?.setQuery?.(e.target.value)}
              placeholder={headerSearch?.placeholder ?? 'Search...'}
              className="pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#00AAFF] focus:border-transparent bg-white shadow-sm w-64"
            />
          </div>
          
          <button className="relative p-2.5 text-slate-400 hover:text-slate-600 hover:bg-slate-50 rounded-xl transition-all">
            <SafeIcon icon={FiBell} className="w-5 h-5" />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full ring-2 ring-white"></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;